import t from"react";import{mdiPencilOutline as i}from"@mdi/js";import{MdIcon as e}from"./MdIcon.js";const o=({id:o="pencil-outline",title:r="Edit",...m})=>t.createElement(e,{id:o,title:r,path:i,...m});export{o as PencilOutlineIcon};
